export const commonStrings: any = {
    selectNoOption: 'Aucun élement trouvé.',
    selectNoOptionMinChar: (nbr: number): string => nbr + ' caractère(s) minimum...',
    tableNoTome: 'Aucun tome trouvé.',
    aucuneDate: 'Aucune date',
};
